import { NgModule } from '@angular/core';
import { LibInfoOutlineIconComponent } from './lib-info-outline-icon.component';

@NgModule({
  declarations: [LibInfoOutlineIconComponent],
  exports: [LibInfoOutlineIconComponent],
})
export class LibInfoOutlineIconModule {}
